module.exports = __webpack_public_path__ + "img/carousel-1.5edea4d3.jpg";